import React from 'react';

type GradientSubmitButtonProps = {
    children?: React.ReactNode; // 👈 ADD THIS LINE
    loading?: boolean;
    onClick?: () => void;
    label?: string;
    loadingLabel?: string;
    type?: 'button' | 'submit';
    showCancel?: boolean;
    onCancel?: () => void;
    disabled?: boolean;
    className?: string;
    gradientFrom?: string;
    gradientTo?: string;
    hoverFrom?: string;
    hoverTo?: string;
    iconSrc?: string;
};

const GradientSubmitButton: React.FC<GradientSubmitButtonProps> = ({
    loading = false,
    onClick,
    label = 'Submit',
    loadingLabel = 'Submitting...',
    type = 'button',
    showCancel = false,
    onCancel,
    iconSrc,
    disabled = false,
    className = '',
    gradientFrom = '#FFA782',
    gradientTo = '#FC583D',
    hoverFrom,
    hoverTo,
}) => {
    const isDisabled = loading || disabled;

    return (
        <div className=" flex justify-end">
            <button
                type={type}
                onClick={!isDisabled ? onClick : undefined}
                disabled={isDisabled}
                className={`px-8 py-2 text-white rounded-3xl flex items-center justify-center gap-2 transition-all
          ${isDisabled
                        ? 'bg-gradient-to-b from-gray-400 to-gray-500 opacity-50 cursor-not-allowed'
                        : className !== '' ? className
                            : 'bg-gradient-to-b from-[#FF7B6F] to-[#F9536B] hover:from-[#FF897A] hover:to-[#F96274]'}`}
            >
                {loading ? (
                    <>
                        <svg
                            className="animate-spin h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                        </svg>
                        {loadingLabel}
                    </>
                ) : (
                    label
                )}
                {iconSrc && (
                    <img
                        src={iconSrc}
                        alt={`${label} Icon`}
                        className="w-4 h-4"
                    />
                )}
            </button>

            {showCancel && (
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={isDisabled}
                    className="px-8 py-2 ml-4 border rounded-3xl disabled:cursor-not-allowed disabled:opacity-50"
                >
                    Cancel
                </button>
            )}
        </div>
    );
};

export default GradientSubmitButton;
